<template>
  <ul
    class="text-text-neutral-tertiary bg-situational-lightgrey list-disc space-y-2 rounded-xl py-4 pl-8 pr-4 text-sm"
  >
    <li>{{ $t('main.cabinClass.rules.youth.noInfants') }}</li>
    <li>{{ $t('main.cabinClass.rules.youth.childAccompany') }}</li>
    <li>{{ $t('main.cabinClass.rules.youth.checkIn') }}</li>
  </ul>
</template>
